import { getCoordinates } from './geolocation'

function updateGroup(selector, checked) {
  document.querySelectorAll(selector).forEach((el) => {
    el.checked = checked
    updateLabel(el)
  })
}

function updateLabel(checkbox) {
  let label = checkbox.getAttribute('id')
  label = label ? document.querySelector(`label[for=${label}]`) : null
  if (label) {
    if (checkbox.checked) {
      label.classList.add('font-semibold')
    } else {
      label.classList.remove('font-semibold')
    }
  }
}

function Setup() {
  // Enter på en kryssruta i filterlådan gör samma sak som "Applicera filter":
  // applicerar och stänger lådan, så att fokus kommer till resultatet.
  // Webbläsarens standard skickade formuläret men lät lådan stå kvar öppen
  // ovanpå resultatet (issue #348). Mellanslag bockar i som vanligt.
  document.addEventListener('keydown', function (event: KeyboardEvent) {
    if (event.key !== 'Enter') return
    const checkbox = (event.target as HTMLElement | null)?.closest(
      '#search-filters input[type=checkbox]'
    )
    if (!checkbox) return
    const apply = document.querySelector(
      '#search-filters [data-apply-filters]'
    ) as HTMLButtonElement | null
    if (apply) {
      event.preventDefault()
      apply.click()
    }
  })

  document.addEventListener('click', function (event) {
    const element = event.target?.closest('.ResetFormButton')
    if (element) {
      const selector = element?.dataset.selector ?? ''
      document.querySelectorAll(selector)?.forEach((checkbox) => {
        checkbox.checked = false
      })
    }
  })

  document.addEventListener('change', function (event) {
    const element = event.target?.closest('#search-filters [type=checkbox]')
    if (element) {
      updateLabel(element)
    }
  })

  document.addEventListener('change', function (event) {
    const element = event.target?.closest('#search-filters [data-parent]')

    if (element) {
      const group = element.dataset.parent
      const allCheckbox = document.getElementById(
        'all-' + group
      ) as HTMLInputElement | null

      if (allCheckbox) {
        allCheckbox.dispatchEvent(new Event('check_group', { bubbles: true }))
      }
    }
  })

  document.addEventListener('check_group', function (event) {
    const element = event.target as HTMLInputElement
    // id is "all-{group}", strip prefix to get the group name
    const id = element?.getAttribute('id') ?? ''
    const group = id.startsWith('all-') ? id.slice(4) : id

    if (group && element) {
      const checked = Array.from(
        document.querySelectorAll(`[data-parent=${group}]`)
      ).every((el: any) => el.checked)
      if (element.checked !== checked) {
        element.checked = checked
      }
      updateLabel(element)
    }
  })

  document.addEventListener('change', function (event) {
    const element = event.target

    if (element && (element as HTMLInputElement).dataset.grouped) {
      const id = element.getAttribute('id') ?? ''
      const group = id.startsWith('all-') ? id.slice(4) : id
      updateGroup(
        `[data-parent=${group}]`,
        (element as HTMLInputElement).checked
      )
    }
  })
  if (htmx) {
    htmx.onLoad(function () {
      document
        .querySelectorAll('#search-filters [type=checkbox]')
        .forEach((checkbox) => {
          updateLabel(checkbox)
        })

      document
        .querySelectorAll('#search-filters [data-grouped]')
        .forEach((checkbox) => {
          checkbox.dispatchEvent(new Event('check_group', { bubbles: true }))
        })
    })
  }
  // Efter ett sidbyte i bläddringen ersätts länken som hade fokus, och fokus
  // hamnade på sidans början. Flytta fokus till resultatrubriken, som också
  // säger vilken sida som visas (issue #377).
  document.body.addEventListener('htmx:afterSettle', function (event) {
    const elt = (event as CustomEvent).detail?.requestConfig?.elt
    if (!(elt instanceof Element) || !elt.hasAttribute('data-search-page')) {
      return
    }
    const heading = document.querySelector<HTMLElement>(
      '#search-results [data-search-results-heading]'
    )
    if (heading) {
      heading.focus({ preventScroll: true })
      heading.parentElement?.scrollIntoView({ block: 'start' })
    }
  })

  document.addEventListener('change', function (event) {
    const element = event.target?.closest('[name=sort]')

    if (element) {
      function submitSearchForm() {
        if (htmx) {
          htmx.trigger('#CourseSearch', 'submit')
        } else {
          document.querySelector('#CourseSearch').submit()
        }
      }

      if (element.value === 'geo') {
        getCoordinates().then(function (coords) {
          const lat = document.querySelector('[name=lat]')
          const lon = document.querySelector('[name=lon]')
          if (lat && lon) {
            lat.removeAttribute('disabled')
            lon.removeAttribute('disabled')
            lat.value = coords.lat
            lon.value = coords.lon
            setTimeout(submitSearchForm, 50)
          }
        })
      } else {
        submitSearchForm()
      }
    }
  })
}

export default Setup
